<template>
  <Can action="store-deal" subject="thread">
    <div data-component-group="threads-dialog" data-component="add-deal">
      <dialog-add
        :title="$t('submit_new_deal')"
        icon="local_offer"
        is-fullscreen
        :is-on="true"
        :on-close="onDialogClose"
      >
        <template v-slot:content>
          <forms-threads-add-deal
            class="elevation-1"
            :is-loading="isAddingDeal"
            :on-cancel="onCancel"
            :on-submit="createDeal"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  import { track } from '../../tracking';

  const { confirm } = window;

  export default {
    emits: ['saved'],
    data() {
      return {
        isAddingDeal: false,
      };
    },
    computed: {
      isDirtyDeal() {
        return this.$store.getters['threads/isDirtyDeal'];
      },
      isDisabledTraking() {
        return !this.$ability.can('track-actions', 'pixel');
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'threads', query: this.$route.query });
      },
      onDialogClose() {
        if (process.env.NODE_ENV !== 'test' && !this.isDisabledTraking) {
          track({
            type: 'click',
            target: {
              name: 'threadsDealAdd',
              data: {
                unitName: 'cancelIcon',
                unitType: 'button',
                event: 'form_tracking',
              },
            },
          });
        }

        if (!this.isDirtyDeal) {
          return this.closeDialog();
        }

        if (confirm('Are you sure you want to leave this page?')) {
          this.closeDialog();
        }
      },
      closeDialog() {
        this.onCancel();
        return this.$store.dispatch('threads/setDirtyDeal', false);
      },
      createDeal(query) {
        this.isAddingDeal = true;

        return this.$store
          .dispatch('threads/createDeal', query)
          .then((res) => {
            const nextThread = { ...this.$store.getters['threads/activeItem'] };
            this.$store.dispatch('threads/setActiveItem', nextThread);
            this.getLimits();
            this.$emit('saved');
            this.$router.push({ name: 'threads', query: this.$route.query });
            return res;
          })
          .catch((error) => error)
          .finally(() => {
            this.isAddingDeal = false;
          });
      },
      getLimits() {
        if (this.$ability.can('view-widget', 'limits')) {
          return this.$store.dispatch('businessUsers/getLimits');
        }
        return [];
      },
    },
  };
</script>
